/**
 * Route for `advertiser-creative-upload`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserCreativeUploadPage } from "../features/advertiser-creative-upload/AdvertiserCreativeUploadPage";

export const advertiserCreativeUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-creative-upload",
	component: AdvertiserCreativeUploadPage,
});

export default advertiserCreativeUploadRoute;
